import { Small } from '@/components/Typography';
import { ImageWithFallback } from '@/components/ImageWithFallback';
import { imagePreviewMessages } from './imagePreview.messages';
import { IconButton } from '@/components/IconButton';

interface ImagePreviewProps {
  images: File[];
  imageUrls: string[];
  onRemoveImage: (index: number) => void;
  className?: string;
}

export function ImagePreview({
  images,
  imageUrls,
  onRemoveImage,
  className = '',
}: ImagePreviewProps) {
  if (images.length === 0) {
    return null;
  }

  return (
    <div
      className={`grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 ${className}`}
    >
      {images.map((image, index) => (
        <div key={index} className="relative">
          <div className="aspect-square overflow-hidden rounded-lg">
            <ImageWithFallback
              src={imageUrls[index]}
              alt={`${imagePreviewMessages.imageAltPrefix} ${index + 1}`}
            />
          </div>
          <IconButton
            icon="X"
            sizeVariant="small"
            buttonVariant="destructive"
            onClick={() => onRemoveImage(index)}
            aria-label={`${imagePreviewMessages.removeImageAriaLabel} ${index + 1}`}
            className="absolute -right-2 -top-2 h-6 w-6 p-0"
          />
          <div className="mt-1 text-center">
            <Small>
              {((image.size / 1024 / 1024) * 100) / 100}{' '}
              {imagePreviewMessages.fileSizeMB}
            </Small>
          </div>
        </div>
      ))}
    </div>
  );
}
